import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import * as Styled from './Checkbox.styled';

const Checkbox = (props) => {
  const {
    classes,
    className,
    variant,
    label,
    labelId,
    onChange,
    checked,
    disabled,
    ...passThroughProps
  } = props;

  return (
    <Styled.Wrapper className={classnames(classes.root, className)}>
      <Styled.InputContainer
        disabled={disabled}
        variant={variant}
        checked={checked}
        className={classes.button}>
        <Styled.InvisibleInput
          type={'checkbox'}
          checked={checked}
          disabled={disabled}
          aria-labelledby={labelId}
          onChange={onChange}
          {...passThroughProps}
        />
        {checked ? <Styled.CheckIcon /> : <Styled.UnCheckIcon />}
      </Styled.InputContainer>
      {label && (
        <Styled.CheckboxLabel
          // If not string then we assume that the component will have the id attribute.
          id={typeof label === 'string' ? labelId : ''}
          disabled={disabled}
          className={classes.label}>
          {label}
        </Styled.CheckboxLabel>
      )}
    </Styled.Wrapper>
  );
};

Checkbox.propTypes = {
  name: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  variant: PropTypes.oneOf(['primary', 'secondary']),
  onChange: PropTypes.func,
  className: PropTypes.string,
  classes: PropTypes.shape({
    root: PropTypes.string,
    button: PropTypes.string,
    label: PropTypes.string,
  }),
  //The label is only intended for straight forward cases. Write a separate label component if needed for complicated cases.
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  labelId: PropTypes.string,
};

Checkbox.defaultProps = {
  name: '',
  labelId: '',
  disabled: false,
  variant: 'primary',
  onChange: () => {},
  className: '',
  classes: {
    root: '',
    button: '',
    label: '',
  },
  label: null,
};

export default Checkbox;
